import apiClient from './api.client'

export interface SpaceConfig {
  maxCards?: number
  maxCopies?: number
  maxReserve?: number
  allowedFactions?: string[]
  bannedCards?: string[]
}

export interface Space {
  id: string
  name: string
  slug: string
  description?: string
  logoUrl?: string
  isPublic: boolean
  config: SpaceConfig
  createdBy: string
  createdAt: string
  memberCount?: number
}

export interface CreateSpaceRequest {
  name: string
  slug: string
  description?: string
  logoUrl?: string
  isPublic?: boolean
  config?: SpaceConfig
}

export const spacesService = {
  async getSpaces(): Promise<Space[]> {
    const response = await apiClient.instance.get<{ success: boolean; data: Space[] }>('/api/spaces')
    return response.data.data
  },

  async getSpace(slug: string): Promise<Space | null> {
    const response = await apiClient.instance.get<{ success: boolean; data: Space }>(`/api/spaces/${slug}`)
    return response.data.success ? response.data.data : null
  },

  async createSpace(space: CreateSpaceRequest): Promise<Space> {
    const response = await apiClient.instance.post<{ success: boolean; data: Space }>('/api/spaces', space)
    return response.data.data
  },

  async updateSpace(slug: string, space: Partial<CreateSpaceRequest>): Promise<void> {
    await apiClient.instance.put(`/api/spaces/${slug}`, space)
  },

  async deleteSpace(slug: string): Promise<void> {
    await apiClient.instance.delete(`/api/spaces/${slug}`)
  },

  async joinSpace(slug: string): Promise<void> {
    await apiClient.instance.post(`/api/spaces/${slug}/join`)
  },

  async leaveSpace(slug: string): Promise<void> {
    await apiClient.instance.post(`/api/spaces/${slug}/leave`)
  },

  async banCard(slug: string, cardId: string, reason?: string): Promise<void> {
    await apiClient.instance.put(`/api/spaces/${slug}/ban-card`, { cardId, reason })
  },

  async unbanCard(slug: string, cardId: string): Promise<void> {
    await apiClient.instance.delete(`/api/spaces/${slug}/ban/${cardId}`)
  },

  async updateMemberRole(slug: string, userId: string, role: string): Promise<void> {
    await apiClient.instance.put(`/api/spaces/${slug}/members/${userId}`, { role })
  },
}
